export const status_filter_form = {
  status_label: "Status",
  status_open: "Open",
  status_closed: "Closed",
};
